module.exports = __webpack_public_path__ + "img/setup.6ec161a1.svg";